import { InfoCard } from '@/components/cards/InfoCard';
import { OverViewInfoCardProps } from '@/services/dashboard/overview/overview.types';

const OverviewInfoCard = ({ dashboardSummaryData }: OverViewInfoCardProps) => {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-5 gap-[1rem] ">
        {dashboardSummaryData.map(({ icon, action, info, title }, index: number) => (
          <InfoCard key={index} icon={icon} info={info} title={title} action={action} helperText={'件'} />
        ))}
      </div>
    </>
  );
};

export default OverviewInfoCard;
